module.exports = __webpack_public_path__ + "static/media/solo31.f3b2ff40.JPG";